class stickyAtc extends HTMLElement {
    constructor() {
      super();
        const _this = this

        this.productForm = _this.querySelector('product-form');

    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setStickyHeight());

        this.setActive()

        const select = this.querySelector('.custom-sticky-select')

        const _this = this

        select?.addEventListener('change', function(sel) {
            _this.activeVariant(select.value)
        })

        if (select) {
            this.activeVariant(select.value) 
        }
    }
    setStickyHeight() {
        document.documentElement.style.setProperty('--sticky-height', `${this.offsetHeight}px`);
    }
    setActive() {
        const _this = this;
        const cartFunctions = document.querySelector('product-info product-form.product-form .product-form__buttons');
        console.log(cartFunctions,"cartFunctionscartFunctions");
        function isOutOfViewport(el) {
            const rect = el.getBoundingClientRect();
            return (
                rect.bottom < 0 || // The element is above the viewport
                rect.top > window.innerHeight // The element is below the viewport
            );
        }
    
        function hasScrolledPast(el) {
            const rect = el.getBoundingClientRect();
            return rect.top < 0; // The element has been scrolled past (its top is above the viewport)
        }
    
        window.addEventListener("scroll", function () {
            /*if (hasScrolledPast(cartFunctions) && isOutOfViewport(cartFunctions)) {
                _this.classList.add("active");
            } else {
                _this.classList.remove("active");
            }*/
           if (isOutOfViewport(cartFunctions)) {
                _this.classList.add("active");
            } else {
                _this.classList.remove("active");
            }
        });
    }

    formatMoney(cents, format) {

		if (typeof cents === 'string') {
			cents = cents.replace('.', '');
		}

		let value = '';
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		const formatString = format || moneyFormat;

		function formatWithDelimiters(number, precision, thousands, decimal) {
			thousands = thousands || ',';
			decimal = decimal || '.';

			if (isNaN(number) || number === null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			const parts = number.split('.');
			const dollarsAmount = parts[0].replace(
				/(\d)(?=(\d\d\d)+(?!\d))/g,
				'$1' + thousands
			);
			const centsAmount = parts[1] ? decimal + parts[1] : '';

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
			case 'amount_no_decimals_with_space_separator':
				value = formatWithDelimiters(cents, 0, ' ');
				break;
			case 'amount_with_apostrophe_separator':
				value = formatWithDelimiters(cents, 2, "'");
				break;
		}

		return formatString.replace(placeholderRegex, value);

	}

    activeVariant(variantID) {
        const idInput = this.querySelector('[name="id"]')
        const atc = this.querySelector('.quick-add__submit')
        const atcText = this.querySelector('.button__text')

        const jsonData = JSON.parse(this.querySelector('noscript').textContent)
        const variant = jsonData.variants.find(e=> e.id == variantID)

      
        if (!variant.available) {
            atc.classList.add('disabled');
            this.productForm.classList.add('disabled-cart');
            atcText.textContent = window.variantStrings.soldOut;
        } else {
            atc.classList.remove('disabled'); 
            this.productForm.classList.remove('disabled-cart');
            //atcText.innerHTML = `${(variant.available ? `<span class="button__text">${window.variantStrings.addToCart}</span> <span class="button__price"> - ${this.formatMoney(variant.price, window.money_format)}</span>` : ``)}`;
            atcText.innerHTML = `${(variant.available ? `<span class="button__text">${window.variantStrings.addToCart}</span>` : ``)}`;
        }

        idInput.value = variant.id
        const mainForm = document.querySelector('product-info product-form.product-form');
        mainForm.querySelector(`input[name="id"]`).value = variant.id;
        mainForm.querySelector(`input[name="id"]`).dispatchEvent(new Event("change"));
    }
}
// Register the custom element
customElements.define('sticky-atc', stickyAtc);